@use '../../../assets/styles/theme';
@use 'sass:color';

.btn {
  flex-shrink: 0;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.02em;
  display: flex;
  flex: 0;
  justify-content: center;
  align-items: center;
  background-color: theme.$lightGray;
  color: theme.$gray-900;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.1);
  outline: none;
  text-decoration: none !important;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 162, 255, 0.15),
                0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  
  &:focus:not(:focus-visible) {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  
  &.mini {
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
  
  &:hover:not(:disabled) {
    background-color: color.scale(theme.$lightGray, $lightness: -3%);
    border-color: rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  }
  
  &:active:not(:disabled) {
    transform: translateY(1px);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
}

.stretch {
  align-self: stretch;
  width: 100%;
}

.raised {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.12);
  
  &:hover:not(:disabled) {
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.16);
  }
  
  &:active:not(:disabled) {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
  }
}

.primary {
  background: linear-gradient(135deg, theme.$orange-500 0%, theme.$orange-600 100%);
  border: 1px solid theme.$orange-600;
  color: white;
  box-shadow: 0 2px 4px 0 rgba(249, 109, 0, 0.2);
  
  &:hover:not(:disabled) {
    background: linear-gradient(135deg, theme.$orange-600 0%, theme.$orange-700 100%);
    border-color: theme.$orange-700;
    box-shadow: 0 4px 8px 0 rgba(249, 109, 0, 0.25);
  }
  
  &:focus {
    box-shadow: 0 0 0 3px rgba(249, 109, 0, 0.2),
                0 2px 4px 0 rgba(249, 109, 0, 0.2);
  }
  
  &:active:not(:disabled) {
    background: theme.$orange-700;
    box-shadow: 0 2px 4px 0 rgba(249, 109, 0, 0.2);
  }
}

.secondary {
  background-color: transparent;
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: theme.$gray-900;
  box-shadow: none;
  
  &:hover:not(:disabled) {
    background-color: rgba(0, 0, 0, 0.04);
    border-color: rgba(0, 0, 0, 0.18);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
  }
  
  &:active:not(:disabled) {
    background-color: rgba(0, 0, 0, 0.08);
    box-shadow: none;
  }
}

.submit {
  background: linear-gradient(135deg, theme.$blue-500 0%, theme.$blue-600 100%);
  border: 1px solid theme.$blue-600;
  color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 162, 255, 0.2);
  
  &:hover:not(:disabled) {
    background: linear-gradient(135deg, theme.$blue-600 0%, color.scale(theme.$blue-600, $lightness: -5%) 100%);
    border-color: color.scale(theme.$blue-600, $lightness: -5%);
    box-shadow: 0 4px 8px 0 rgba(0, 162, 255, 0.25);
  }
  
  &:focus {
    box-shadow: 0 0 0 3px rgba(0, 162, 255, 0.2),
                0 2px 4px 0 rgba(0, 162, 255, 0.2);
  }
  
  &:active:not(:disabled) {
    background: color.scale(theme.$blue-600, $lightness: -5%);
    box-shadow: 0 2px 4px 0 rgba(0, 162, 255, 0.2);
  }
  
  &:disabled {
    background: theme.$blue-100 !important;
    border-color: theme.$blue-200 !important;
    color: rgba(255, 255, 255, 0.7) !important;
  }
}
